export const OnlineEmployeePermissionsOptions = [
  {
    key: "FINANCE",
    title: "FINANCE",
    value: "FINANCE"
  },
  {
    key: "PAYMENTLINK",
    title: "PAYMENTLINK",
    value: "PAYMENTLINK"
  },
  {
    key: "MERCHANT_ADMIN",
    title: "MERCHANT_ADMIN",
    value: "MERCHANT_ADMIN"
  },
  {
    key: "MERCHANT",
    title: "MERCHANT",
    value: "MERCHANT"
  },
]